import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const TrippleBeltedHighNeckVest = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.TrippleBeltedHighNeckVest.itemName}
      name={AW23.tops.TrippleBeltedHighNeckVest.itemName}
      price={AW23.tops.TrippleBeltedHighNeckVest.itemPrice}
      fabric={AW23.tops.TrippleBeltedHighNeckVest.itemFabric}
      src={AW23.tops.TrippleBeltedHighNeckVest.sizeChart}
      divId={AW23.tops.TrippleBeltedHighNeckVest.shopifyDivId}
      mainId={AW23.tops.TrippleBeltedHighNeckVest.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.TrippleBeltedHighNeckVest.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.TrippleBeltedHighNeckVest.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default TrippleBeltedHighNeckVest;
